/**
 * Merapikan nilai kontak yang diketik admin menjadi link yang valid.
 * Admin bebas menulis "0812-3456-7890", "+62 812...", atau "instagram.com/x".
 */

/** Nomor WhatsApp untuk wa.me: hanya angka, format internasional ("08xx" -> "628xx"). */
export const toWhatsappNumber = (raw: string): string => {
  const digits = raw.replace(/\D/g, "");

  return digits.startsWith("0") ? `62${digits.slice(1)}` : digits;
};

export const toWhatsappHref = (raw: string): string =>
  `https://wa.me/${toWhatsappNumber(raw)}`;

/** Nomor telepon untuk tel: angka dan "+" saja (spasi, "-", "()" dibuang). */
export const toTelHref = (raw: string): string =>
  `tel:${raw.replace(/[^\d+]/g, "")}`;

/**
 * Akun/URL media sosial: "https://..." dipakai apa adanya, "@akun" menjadi
 * profil Instagram, "instagram.com/akun" diberi "https://".
 */
export const toInstagramHref = (raw: string): string => {
  const value = raw.trim();

  if (/^https?:\/\//i.test(value)) return value;

  if (value.startsWith("@")) {
    return `https://instagram.com/${value.slice(1)}`;
  }

  return `https://${value.replace(/^\/+/, "")}`;
};

/**
 * Nama akun untuk ditampilkan dari isian admin: "@akun", "https://instagram.com/akun/"
 * dan "instagram.com/akun" semuanya menjadi "akun".
 */
export const toSocialHandle = (raw: string): string => {
  const value = raw.trim();
  const withoutScheme = value.replace(/^https?:\/\//i, "");
  const path = withoutScheme.includes("/")
    ? withoutScheme.slice(withoutScheme.indexOf("/") + 1)
    : withoutScheme;

  return path.replace(/^@/, "").split(/[/?#]/)[0] || value;
};

/** Link Google Maps yang mencari alamat tersebut (alamat multi-baris digabung dengan koma). */
export const toMapsHref = (address: string): string =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
    address
      .split(/\r?\n+/)
      .map((line) => line.trim())
      .filter(Boolean)
      .join(", ")
  )}`;
